import React, { Component } from 'react';
import Slider from 'react-slick';
import '../../../node_modules/slick-carousel/slick/slick.css';
import '../../../node_modules/slick-carousel/slick/slick-theme.css';
import TestimFamily from '../../images/testimfamily.png';

const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 5000,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
};

const dotsSettings = {
    dots: false,
    autoplay: true,
    autoplaySpeed: 5000,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 5,
    slidesToScroll: 1,
    focusOnSelect: true,
};
class WhatParentsSay extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nav1: null,
            nav2: null,
        };
    }

    componentDidMount() {
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
        });
    }

    render() {
        return (
            <section className="page-section bg-secondary text-white testimsec">
                <h2 className="yellowtxt">What Parents Say</h2>
                <div
                    id="myCarousel"
                    className="carousel slide"
                    data-ride="carousel"
                >
                    <Slider
                        asNavFor={this.state.nav2}
                        ref={slider => (this.slider1 = slider)}
                        {...dotsSettings}
                        className="carousel-indicators"
                    >
                        <li></li>
                        <li></li>
                        <li></li>
                        <li></li>
                        
                    </Slider>
                    <Slider
                        {...settings}
                        asNavFor={this.state.nav1}
                        ref={slider => (this.slider2 = slider)}
                        className="carousel-inner"
                    >
                        <div className="item carousel-item active">
                            <p className="testimonial">
                            “Such an amazing first time experience! Went about 30 minutes before closing and left about 6:55pm, they didn't rush us to leave or anything. It's nice to have a place like this where our kids could play and be free. There was plenty for my kids to play with and also there's staff members there to help and keep watch, so there's an extra set of eyes always. I will be adding this routine to my schedule because I know my kids will look forward to coming once a week. It's worth the drive !!”</p>
                            <p className="overview">Roxanna H. </p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “Perfect place for our special needs children! My daughter had fun exploring the gym, trying out different sensory safe equipment, and even the calming room to regulate after. Give them a visit! You will love it!”</p>
                            <p className="overview">Jays Mama</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “An absolute wonderful experience. Other kids places can be rather overstimulating for my child and I. This place was a calm with a friendly environment for everyone. It has many different things to do throughout while still not feeling overwhelming. Great for all kids!”</p>
                            <p className="overview">Tiffany T.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “We’ve been twice now, and I cannot fully express how grateful we are to have this as a fixture in our community. As if it couldn’t get better, this evening (Monday) we were invited to participate in a parent support group while the staff were SO kind and kept a close eye on our little ones. I spoke with some of the most amazing people and walked away feeling like I got a much needed mental reset. Thank you so much for everything you do for our community!”</p>
                            <p className="overview">Tina G.</p>
                        </div>
                        <div className="item carousel-item">
                            <p className="testimonial">
                            “My son loves it here! It's clean and safe and has multiple different options for kids to enjoy!”</p>
                            <p className="overview">Erica H.</p>
                        </div>
                        
                    </Slider>
                    <img
                        className="quoteimg"
                        src={TestimFamily}
                        alt="Testimonials family"
                    />
                </div>
            </section>
        );
    }
}

export default WhatParentsSay;
